<template>
  <div id="activity" class="maincont">
    <div class="gm-maincont">
      <div class="ef--inner">

        <div class="graphlist-header">
          <h2 class="graphlist-header-caption">グラフ一覧</h2>
          <ul class="graphlist-header-button">
            <li class="graphlist-header-button-item"><button @click="clickCreate2Graph()" id="graph-maintenance-bt"
                class="graph-header-button">グラフ新規作成</button></li>
            <li class="graphlist-header-button-item"><button @click="clickMove2Bulkchange()" id="graph-bulk-change-bt"
                class="graph-header-button">グラフ一括編集</button>
            </li>
          </ul>
        </div>

        <div class="graphlist-list-container">
          <table class="normal-table graphlist-table">
            <thead>
              <tr>
                <th class="ma-w-10-p">No.</th>
                <th class="m-w-500-p">グラフ名称</th>
                <th class="m-w-30-p">グラフ表示</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in itemGraphList" v-bind:key="index">
                <td>{{ index + 1 }}</td>
                <td class="graphlist-graphname">{{ item.graphName }}</td>
                <td>
                  <a @click="clickMove2Graph(item.graphId)">
                    <img src="@/assets/images/common/icon_002.png" alt="グラフ画面遷移">
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "MultiCircuitGraphlist",

  components: {
  },

  data: function () {
    return {
      itemGraphList: null,
    };
  },

  watch: {
  },

  computed: {
  },

  mounted: function () {
    this.getGraphInfoList();
  },

  methods: {
    /* SA1-Ⅲグラフ情報取得 */
    getGraphInfoList: function () {
      this.$axios
        .get(`/srv/api/multi_circuit_graph_info_list/${this.$store.state.loginID}`, {
          withCredentials: true
        })
        .then(response => {
          this.info = response.data;
          this.itemGraphList = Object.create(response.data.multi_circuit_graphinfo_list);
          this.chackGraphInfoList();
        })
        .catch(error => {
          console.error(error);
        });
    },

    /* 取得したグラフ情報リストを確認する処理 */
    chackGraphInfoList: function () {
      if (this.itemGraphList.length === 0) {
        document.getElementById("graph-bulk-change-bt").className = "graph-header-button-inactive";
      } else if (this.itemGraphList.length > 99) {
        document.getElementById("graph-maintenance-bt").className = "graph-header-button-inactive";
      }
    },

    /* ページ移動処理(グラフ新規作成画面遷移) */
    clickCreate2Graph: function () {
      this.$store.dispatch("setGraphID", null);
      this.$router.push('multi_circuit_graph_maintenance');
    },

    /* ページ移動処理(グラフ一括編集画面遷移) */
    clickMove2Bulkchange: function () {
      this.$router.push('multi_circuit_graph_bulk_change');
    },

    /* ページ移動処理(グラフ画面遷移) */
    clickMove2Graph: function (graphId) {
      this.$store.dispatch("setGraphID", graphId);
      this.$router.push('multi_circuit_graph');
    },
  },
};
</script>
<style scoped>
/* グラフ一覧のボタンの配置 */
.graphlist-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: auto;
  background-color: #5ca1d6;
  border-radius: 8px 8px 0 0;
  min-height: 45px;
  padding: 0 15px 5px;
}

.graphlist-header-caption {
  color: #FFFFFF;
  font-size: 18px;
  line-height: 45px;
}

/* グラフ一覧のボタンの見た目 */
.graphlist-header-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

/* グラフのボタンの幅 */
.graphlist-header-button-item {
  margin: 0 auto;
  margin-left: 10px;
}

/* グラフ一覧のボタンの背景、文字色 */
.graphlist-header-button .bt {
  display: inline-block;
  background-color: #fff;
  border-radius: 20px;
  padding: 4px 14px;
  color: #444;
  font-size: 14px;
}

/* グラフ一覧のボタンをマウスオーバーしたときの色 */
.graphlist-header-button .bt:hover {
  opacity: .8;
}

/* 表テーブルの枠 */
.graphlist-list-container {
  overflow: auto;
  display: flex;
  width: auto;
  max-height: 500px;
  margin-bottom: 20px;
}

/* 表の列の幅 */
.m-w-500-p {
  min-width: 500px !important;
}

.m-w-30-p {
  min-width: 30px !important;
}

.ma-w-10-p {
  max-width: 10px !important;
}

/* グラフ名称の配置 */
.graphlist-graphname {
  text-align: left !important;
  text-indent: 1em;
}

.graphlist-table {
  width: 1202px;
}

/* グラフの表の行の高さ設定 */
.graphlist-table tbody td {
  padding: 5px 0 !important;
}

.graphlist-table thead th {
  position: sticky;
}

.graph-header-button {
  display: inline-block;
  background-color: #fff;
  border-radius: 20px;
  padding: 4px 14px;
  color: #444;
  font-size: 14px;
}

.graph-header-button:hover {
  opacity: .8;
}

.graph-header-button-inactive {
  pointer-events: none;
  background-color: #dddddd;
  border-radius: 20px;
  padding: 4px 14px;
  color: #ffffff;
  font-size: 14px;
}
</style>